import { formatAMPM } from "@cart-ui/helpers/CartFooter";

export const convertToDisplaySlot = (startTime: number, endTime: number): string => {
    return `${formatAMPM(startTime)} - ${formatAMPM(endTime)}`;
};
